import React, { useContext, useState } from "react";
import Context from "../../Context";
export default function Fav(props) {
  const cx = useContext(Context);
  const [pending, setPending] = useState(false);

  const favItem = cx.fav.getItem(props.itemId);

  const favClick = (e) => {
    e.preventDefault();
    if (favItem.id) {
      favRemove();
    } else {
      favAdd();
    }
  };

  const favAdd = async () => {
    if (props.itemId) {
      setPending(true);
      let result = await cx.fav.addItem(props.itemId);
      if (result === false) {
        cx.toast("Не удалось добавить в избранное", "error");
      } else {
        cx.toast("Добавлено в избранное", "success");
      }
      cx.force();
      setPending(false);
    }
  };

  const favRemove = async () => {
    if (props.itemId) {
      setPending(true);
      let result = await cx.fav.deleteItem(props.itemId);
      if (result === false) {
        cx.toast("Не удалось убрать из избранного", "error");
      } else {
        cx.toast("Убрано из избранного", "success");
      }
      cx.force();
      setPending(false);
    }
  };

  return (
    <>
      <span onClick={favClick} className={props.className}>
        {pending ? (
          <div
            title="Добавить в избранное"
            className="spinner-border spinner-border-sm text-muted opacity-50"
          ></div>
        ) : (
          <>
            {favItem.id ? (
              <i className="fa fa-star text-warning"></i>
            ) : (
              <i className="fa fa-star-o"></i>
            )}
          </>
        )}
      </span>
    </>
  );
}
